import _regeneratorRuntime from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import cx from 'clsx';
import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { WallModal } from '../WallModal';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { CircularProgress, Skeleton } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { ReactIntl, InitIntl } from '../../helpers/intel';
import { ClientNames } from '../../models'; // ----------------------------------------------------------------------

var magnolia = '#F8F6FF';
var purple = '#824179';
var grayText = '#828282';
var useStyles = makeStyles(function (theme) {
  return {
    cont: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: theme.spacing(3)
    },
    item: {
      marginRight: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      borderRadius: 3,
      cursor: 'pointer',
      width: '30%',
      maxWidth: '120px',
      '&:hover': {
        backgroundColor: magnolia,
        '& span': {
          color: "".concat(purple, " !important")
        }
      }
    },
    normalBorder: {
      border: '1px solid #C8CDD4'
    },
    selectedBorder: {
      backgroundColor: "".concat(magnolia, " !important"),
      border: "1px solid ".concat(purple),
      '& span': {
        color: purple
      }
    },
    mr: {
      marginRight: '10px'
    },
    mb: {
      marginBottom: '10px'
    },
    totalContainer: {
      justifyContent: 'space-between',
      marginTop: '10px',
      flexDirection: 'row',
      backgroundColor: magnolia,
      padding: '15px',
      borderRadius: 3,
      width: '100%'
    },
    itemsFlexEnd: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    imageBorder: _defineProperty({
      display: 'none',
      width: '46px',
      height: '38px',
      backgroundColor: magnolia,
      borderRadius: '8px',
      marginRight: '10px'
    }, theme.breakpoints.up('lg'), {
      display: 'flex'
    }),
    linkDecoration: {
      textDecoration: 'underline !important',
      display: 'block',
      width: '100%',
      textAlign: 'center',
      fontSize: '0.875rem',
      marginTop: '10px'
    },
    textAlign: _defineProperty({
      textAlign: 'center'
    }, theme.breakpoints.up('md'), {
      textAlign: 'left'
    }),
    selectHeader: _defineProperty({
      textAlign: 'center'
    }, theme.breakpoints.up('md'), {
      textAlign: 'left'
    }),
    unsetPosition: {
      backgroundPosition: 'unset !important'
    },
    lowerCase: {
      textTransform: 'lowercase'
    },
    overlay: {
      width: '100%',
      height: '80px',
      position: 'absolute',
      background: '#fff',
      zIndex: 2,
      opacity: '0.4',
      top: '48px'
    }
  };
});
export var TopUpAssetsModal = function TopUpAssetsModal(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      isFreeUser = _ref.isFreeUser,
      router = _ref.router,
      subscription = _ref.subscription,
      multiSeatRole = _ref.multiSeatRole,
      currentLanguage = _ref.currentLanguage,
      listTopUpApi = _ref.listTopUpApi,
      generateCheckoutUrlApi = _ref.generateCheckoutUrlApi,
      isLocal = _ref.isLocal,
      clientName = _ref.clientName,
      freeRedirectPath = _ref.freeRedirectPath;

  var _useState = useState(InitIntl()),
      _useState2 = _slicedToArray(_useState, 2),
      intl = _useState2[0],
      setIntl = _useState2[1];

  var fetchIntel = useCallback(function (lng) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = setIntl;
              _context.next = 3;
              return ReactIntl(lng || 'en', 'top-up-modal');

            case 3:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  }, []);
  useEffect(function () {
    fetchIntel(currentLanguage);
  }, [currentLanguage]);
  return React.createElement(React.Fragment, null, show && React.createElement(TopUpModal, {
    intl: intl,
    show: show,
    onClose: onClose,
    isFreeUser: isFreeUser,
    router: router,
    subscription: subscription,
    multiSeatRole: multiSeatRole,
    listTopUpApi: listTopUpApi,
    generateCheckoutUrlApi: generateCheckoutUrlApi,
    isLocal: isLocal,
    clientName: clientName,
    freeRedirectPath: freeRedirectPath
  }));
};

var ImageTopUp = function ImageTopUp(_ref2) {
  var intl = _ref2.intl,
      topUpData = _ref2.topUpData,
      selected = _ref2.selected,
      handleSelected = _ref2.handleSelected;
  var classes = useStyles();
  return React.createElement(Box, {
    component: 'div',
    display: 'flex',
    flexDirection: 'row'
  }, React.createElement(Box, {
    className: classes.imageBorder
  }, React.createElement(Box, {
    component: 'img',
    src: '/img/imageAssets.svg',
    width: 20,
    height: 20,
    margin: '10px'
  })), React.createElement(Box, {
    component: 'div',
    mt: '5px',
    width: '100%'
  }, React.createElement(Typography, {
    variant: 'h6',
    mb: '10px',
    className: classes.selectHeader
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'asset_name_2',
    defaultMessage: 'Images'
  })), React.createElement(Typography, {
    variant: 'subtitle2',
    className: classes.selectHeader
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'tu_modal_assets_images_select',
    defaultMessage: 'Select the number of images'
  })), React.createElement(Box, {
    className: classes.cont
  }, topUpData.length === 0 ? React.createElement(Box, {
    component: 'div',
    display: 'flex',
    flexDirection: 'row'
  }, React.createElement(Skeleton, {
    width: '120px',
    height: '66px',
    className: classes.mr
  }), React.createElement(Skeleton, {
    width: '120px',
    height: '66px',
    className: classes.mr
  }), React.createElement(Skeleton, {
    width: '120px',
    height: '66px'
  })) : topUpData.map(function (asset, idx) {
    return React.createElement(Fragment, {
      key: idx
    }, asset.category === '123rf' ? React.createElement(Box, {
      onClick: function onClick(e) {
        e.preventDefault();
        handleSelected(idx, asset);
      },
      className: cx(classes.item, selected === idx ? classes.selectedBorder : classes.normalBorder)
    }, React.createElement(Typography, {
      variant: 'button',
      align: 'center'
    }, asset.name.match(/\d/g).join('')), React.createElement(Typography, {
      variant: 'button',
      align: 'center',
      color: grayText,
      className: classes.lowerCase
    }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'asset_name_2',
      defaultMessage: 'Images'
    }))) : '');
  }))));
};

var VideoTopUp = function VideoTopUp(_ref3) {
  var intl = _ref3.intl,
      topUpData = _ref3.topUpData,
      selected = _ref3.selected,
      handleSelected = _ref3.handleSelected;
  var classes = useStyles();
  return React.createElement(Box, {
    display: 'flex',
    flexDirection: 'row'
  }, React.createElement(Box, {
    className: classes.imageBorder
  }, React.createElement(Box, {
    component: 'img',
    src: '/img/videoAssets.svg',
    width: 20,
    height: 20,
    margin: '10px'
  })), React.createElement(Box, {
    component: 'div',
    mt: '5px',
    width: '100%'
  }, React.createElement(Typography, {
    variant: 'h6',
    className: classes.selectHeader,
    mb: '10px'
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'asset_name_3',
    defaultMessage: 'Videos'
  })), React.createElement(Typography, {
    variant: 'subtitle2',
    className: classes.selectHeader
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'tu_modal_assets_videos_select',
    defaultMessage: 'Select the number of videos'
  })), React.createElement(Box, {
    className: classes.cont
  }, topUpData.length === 0 ? React.createElement(Box, {
    component: 'div',
    display: 'flex',
    flexDirection: 'row'
  }, React.createElement(Skeleton, {
    width: '120px',
    height: '66px',
    className: classes.mr
  }), React.createElement(Skeleton, {
    width: '120px',
    height: '66px',
    className: classes.mr
  }), React.createElement(Skeleton, {
    width: '120px',
    height: '66px'
  })) : topUpData.map(function (asset, idx) {
    return React.createElement(Fragment, {
      key: idx
    }, asset.category === 'getty' ? React.createElement(Box, {
      onClick: function onClick(e) {
        e.preventDefault();
        handleSelected(idx, asset);
      },
      className: cx(classes.item, selected === idx ? classes.selectedBorder : classes.normalBorder)
    }, React.createElement(Typography, {
      variant: 'button',
      align: 'center'
    }, asset.name.match(/\d/g).join('')), React.createElement(Typography, {
      variant: 'button',
      align: 'center',
      color: 'GrayText',
      className: classes.lowerCase
    }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'asset_name_3',
      defaultMessage: 'Videos'
    }))) : '');
  }))));
};

var Total = function Total(_ref4) {
  var intl = _ref4.intl,
      topUpData = _ref4.topUpData,
      val = _ref4.val;
  var classes = useStyles();
  return React.createElement(Box, {
    component: 'div',
    display: 'flex',
    className: classes.totalContainer
  }, React.createElement(Typography, {
    variant: 'h6',
    align: 'left',
    display: 'flex',
    alignItems: 'center'
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'total',
    defaultMessage: 'Total'
  })), React.createElement(Box, {
    component: 'div',
    className: classes.itemsFlexEnd
  }, topUpData.length === 0 ? React.createElement(Box, {
    component: 'div',
    className: classes.itemsFlexEnd
  }, React.createElement(Skeleton, {
    width: '95px',
    height: '28px',
    className: classes.mb
  }), React.createElement(Skeleton, {
    width: '166px',
    height: '22px'
  })) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: 'h6',
    align: 'left',
    mb: '10px',
    display: 'flex',
    justifyItems: 'center'
  }, "".concat(val.currency, " ").concat(val.price)), React.createElement(Typography // className={classes.lowerCase}
  , {
    // className={classes.lowerCase}
    variant: 'subtitle2',
    align: 'left',
    mb: '0',
    color: grayText
  }, "".concat(val.currency, " ").concat(val.price_per_asset, " / ").concat(val.category === 'getty' ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'video',
    defaultMessage: 'Video'
  }) : intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'image',
    defaultMessage: 'Image'
  }))))));
};

var AssetsSelect = function AssetsSelect(_ref5) {
  var val = _ref5.val,
      setVal = _ref5.setVal,
      intl = _ref5.intl,
      listTopUpApi = _ref5.listTopUpApi,
      isFreeUser = _ref5.isFreeUser,
      multiSeatRole = _ref5.multiSeatRole,
      setLoading = _ref5.setLoading;
  var classes = useStyles();

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      topUpData = _useState6[0],
      setTopUpData = _useState6[1];

  var handleSelected = function handleSelected(key, asset) {
    setSelected(key);
    setVal(Object.assign(Object.assign({}, val), {
      currency: asset.currency,
      price: asset.price,
      sku: asset.sku,
      name: asset.name,
      category: asset.category,
      price_per_asset: asset.price_per_asset
    }));
  };

  useEffect(function () {
    function getTopUpList() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                setLoading(true);
                _context2.next = 4;
                return listTopUpApi();

              case 4:
                response = _context2.sent;
                setTopUpData(response.data);
                setVal(response.data[0]);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 12:
                _context2.prev = 12;
                setLoading(false);
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9, 12, 15]]);
      }));
    }

    getTopUpList();
  }, []);
  return React.createElement(Box, {
    component: 'div'
  }, React.createElement(ImageTopUp, {
    intl: intl,
    selected: selected,
    topUpData: topUpData,
    handleSelected: handleSelected
  }), React.createElement(Box, {
    paddingY: '15px'
  }), React.createElement(VideoTopUp, {
    intl: intl,
    selected: selected,
    topUpData: topUpData,
    handleSelected: handleSelected
  }), React.createElement(Box, {
    paddingY: '10px'
  }), React.createElement(Total, {
    intl: intl,
    topUpData: topUpData,
    val: val
  }), React.createElement(Box, {
    paddingY: '10px'
  }), isFreeUser && React.createElement(Box, {
    component: 'div',
    display: 'flex',
    flexDirection: 'row'
  }, React.createElement(ErrorIcon, {
    color: 'error'
  }), React.createElement(Typography, {
    variant: 'subtitle2',
    color: 'error',
    align: 'left',
    ml: '10px'
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'tu_modal_image_request',
    defaultMessage: 'You need to be a Pro user to use premium images'
  }))), multiSeatRole !== 'Owner' && React.createElement(Box, {
    component: 'div',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative'
  }, React.createElement(ErrorIcon, {
    color: 'error'
  }), React.createElement(Typography, {
    variant: 'subtitle2',
    color: 'error',
    align: 'left',
    ml: '10px'
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'tu_permission',
    defaultMessage: 'You do not have permission to top up premium images.'
  })), React.createElement(Box, {
    component: 'div',
    className: classes.overlay
  })));
};

var TopUpModal = function TopUpModal(_ref6) {
  var intl = _ref6.intl,
      show = _ref6.show,
      onClose = _ref6.onClose,
      isFreeUser = _ref6.isFreeUser,
      router = _ref6.router,
      subscription = _ref6.subscription,
      multiSeatRole = _ref6.multiSeatRole,
      listTopUpApi = _ref6.listTopUpApi,
      generateCheckoutUrlApi = _ref6.generateCheckoutUrlApi,
      isLocal = _ref6.isLocal,
      clientName = _ref6.clientName,
      freeRedirectPath = _ref6.freeRedirectPath;
  var classes = useStyles();

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      val = _useState8[0],
      setVal = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  function checkoutSku() {
    return __awaiter(this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              setLoading(true);
              _context3.next = 4;
              return generateCheckoutUrlApi(val.sku);

            case 4:
              response = _context3.sent;
              window.location.href = response.data.checkout_url;
              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              setLoading(false);
              console.error(_context3.t0);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 8]]);
    }));
  }

  return React.createElement(WallModal, {
    title: ' ',
    bannerImgUrl: "".concat(isLocal ? 'https://dev.designs.ai' : '', "/img/assets-topup.png"),
    ctaOnClick: multiSeatRole !== 'Owner' ? function () {} : !isFreeUser ? function () {
      checkoutSku();
    } : function () {
      if (router) {
        router.push('/pricing');
      } else {
        var url = '';

        switch (clientName) {
          case ClientNames.logomaker:
            url = '/logomaker';
            break;

          case ClientNames.videomaker:
            url = '/videomaker';
            break;

          case ClientNames.speechmaker:
            url = '/speechmaker';
            break;

          case ClientNames.designmaker:
            url = '/designmaker';
            break;

          default:
        }

        window.location.href = "".concat(isLocal ? 'https://dev.designs.ai' : '', "/pricing").concat(url).concat(freeRedirectPath ? "?redirect=".concat(freeRedirectPath) : '');
      }
    },
    show: show,
    onClose: onClose,
    ctaText: loading === true ? React.createElement(CircularProgress, {
      sx: {
        zIndex: 3
      },
      color: 'secondary',
      size: '16px'
    }) : multiSeatRole !== 'Owner' ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'tu_request_permission',
      defaultMessage: 'Request admin to purchase'
    }) : !isFreeUser ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'pay_now',
      defaultMessage: 'Pay Now'
    }) : intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'subscribe',
      defaultMessage: 'Subscribe Now'
    }),
    header: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'tu_modal_title',
      defaultMessage: 'Top up Premium Assets'
    }),
    description: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'tu_modal_description',
      defaultMessage: 'Purchase premium images and videos to create end products with Designs.ai tools.'
    }),
    customListComponent: React.createElement(AssetsSelect, {
      val: val,
      setVal: setVal,
      intl: intl,
      listTopUpApi: listTopUpApi,
      isFreeUser: isFreeUser,
      multiSeatRole: multiSeatRole,
      setLoading: setLoading
    }),
    subLink: subscription === 'basic' ? '/pricing' : '',
    subLinkText: subscription === 'basic' ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'upgrade_plan',
      defaultMessage: 'Upgrade plan for a better deal'
    }) : '',
    subLinkStyle: classes.linkDecoration,
    alignment: classes.textAlign,
    overidePosition: classes.unsetPosition,
    dataLoading: loading
  });
};